import React from 'react';
import { connect } from 'react-redux';

import { getStagesFromTournamentsSelector } from '../selectors/entities';
import Stage from './Stage';

// TODO: если появилось свободное время, допишите сюда типы
// InterestingMatchesTournament.propTypes = {
//   tournamentId: PropTypes.number.isRequired,
// };


export function InterestingMatchesTournament({ tournamentStages }) {
  return tournamentStages.toList().map((tournamentStage) => (
    <Stage tournamentStageId={tournamentStage.id}
           key={tournamentStage.id} />
  ));
}

const mapStateToProps = (state, { tournamentId }) => ({
  tournamentStages: getStagesFromTournamentsSelector(state, tournamentId),
});

export default connect(mapStateToProps)(InterestingMatchesTournament);
